import React, { createContext, useState } from 'react';

export const AreaContext = createContext();

export const AreaProvider = ({ children }) => {
    const [areaContentLength, setAreaContentLength] = useState(0);
    const [areaUsersCount, setAreaUsersCount] = useState(0);

    return (
        <AreaContext.Provider value={{ areaContentLength, setAreaContentLength, areaUsersCount, setAreaUsersCount }}>
            {children}
        </AreaContext.Provider>
    );
};
